import React from "react";
import ReactApexChart from "react-apexcharts";

export default function DonutChart({ chartType = "donut", chartData, labelPosition, height = 350, width = "100%" }) {
  let series = chartData?.data || [44];
  let options = {
    chart: {
      type: chartType,
      height: height,
      width: width,
      toolbar: {
        show: false
      }
    },
    labels: chartData?.labels || [],
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex]
      }
    },
    legend: {
      show: chartData?.labels?.length > 0,
      position: labelPosition || "bottom",
      fontSize: '14px',
      markers: {
        width: 12,
        height: 12,
        radius: 6
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '14px',
              offsetY: -10
            },
            value: {
              show: true,
              fontSize: '20px',
              offsetY: 5,
              formatter: function (val) {
                return val
              }
            },
            total: {
              show: true,
              label: 'Total',
              fontSize: '14px',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
              }
            }
          }
        }
      }
    },
    stroke: {
      width: 0
    },
    colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  return (
    <div style={{ height: height }}>
      <ReactApexChart 
        options={options} 
        series={series} 
        type={chartType} 
        height={height}
        width={width}
      />
    </div>
  );
}